module.exports = __webpack_public_path__ + "static/media/imagery3.76fcf4cf.jpg";